import React from "react";
import { UserSearchDialogContent, UserSearchDialogStateProvider } from ".";

export const UserSearchDialog = () => {
  return (
    <UserSearchDialogStateProvider>
      <UserSearchDialogContent></UserSearchDialogContent>
    </UserSearchDialogStateProvider>
  );
};
